/**
 * Copyright (c) 2023-present,
 * Eunoia Digital, S.L. All rights reserved.
 */

import getConfig from "../lib/runtime-config";

const { publicRuntimeConfig } = getConfig();

export const settings = {
  FRONT_BASE_URL: "https://www.manvert.com",
  URL_SEO:
    process.env.entorno === "pre"
      ? "https://pre.manvert.com" //cambiar por localhost si se requiere http://localhost:3000"
      : "https://manvert.com",
  API_BASE_URL:
    process.env.entorno === "pre"
      ? "https://api-pre.biovert.es/"
      : "https://api.biovert.es/",
  GET_COUNTRY_SERVICE_URL: "https://ipinfo.io/",
  BIOVERT_CMS: "https://cms.biovert.es/",
  TOKEN_IPINFO: "bcf93d881fede9",
  PRODUCTOS_LIGNOVERT: [30, 38, 69],
  PRODUCTOS_SEAVERT: [40, 45, 46],
  PRODUCTOS_NEOVERT: [47],
  EMAIL_DEFAULT_HEADER: "MANVERT-FORM",
  BIOVERT_EMPRESA: "manvert",
  DEFAULT_LANG: "en_US",
  DEFAULT_LANG_GENERIC: "en",
  DEFAULT_COUNTRY: "es",
  DEFAULT_COUNTRY_NAME: "Spain",
  I18N_FALLBACK: "en",
  PRODUCTOS_DESTACADOS: [
    {
      id: 40,
      url: "https://www.foliplus.com/ ",
    },
    {
      id: 47,
      url: "https://www.manvertsilikon.com/",
    },
    {
      id: 44,
      url: "https://www.manvertmovilica.com/",
    },
  ],
  COOKIES: {
    THIRD_PARTY: "c_third_party",
    TECHNICAL: "c_technical",
    DECIDED: "c_has_decided",
  },
  google: {
    URL_BIOVERT_GOOGLE_RECAPTCHA_KEY:
      "https://www.google.com/recaptcha/enterprise.js?render=6Lf8GpsjAAAAAFsVhyJJff0pZ5JLwRRvKh5pCXJh",
    BIOVERT_GOOGLE_RECAPTCHA_KEY: "6Lf8GpsjAAAAAFsVhyJJff0pZ5JLwRRvKh5pCXJh",
  },
  redis: {
    host: publicRuntimeConfig.BIOVERT_REDIS_HOST,
    port: publicRuntimeConfig.BIOVERT_REDIS_PORT,
  },
  countryCookie: "manvert-country",
  CookieConsent: "CookieConsent",
  MAX_SCORE: 0.7,
};

export const endpoints = {
  back: {
    gruposDeCultivo: "api/public/grupos-de-cultivo/",
    cultivos: "api/public/cultivos/",
    familias: "api/public/familias/",
    productos: "api/public/productos/",
    allproducts: "api/public/sitemap/productos-acabados/",
    producto_detalle: "api/public/producto/",
    producto_detalle_generico: "api/public/producto_generico/",
    productos_genericos: "api/public/productos-genericos/",
    productosGenericos: "api/public/sitemap/productos-genericos/",
    soluciones: "api/public/soluciones/",
    ensayos: "api/public/ensayos/",
    ensayosActivos: "api/public/sitemap/ensayos-activos/",
    paises: "api/public/paises/",
    enviarFormulario: "api/public/enviar-formulario/",
    enviarFormularioSalesforce:
      "https://go.pardot.com/l/939633/2021-09-08/fpjvt5",
    prodRedes: "api/public/producto-acabado-slug/",
  },
  cms: {
    noticias: "noticias/",
    medios: "manvert-medios/",
    multimedia: "multimedias/",
    logos: "logos/",
    catalogo: "catalogos/",
  },
  google: {
    verifyUrl: `https://www.google.com/recaptcha/api/siteverify?secret=${publicRuntimeConfig.BIOVERT_GOOGLE_RECAPTCHA_SECRET}&response=`,
  },
};
